export default __webpack_public_path__ + "assets/images/rupay.453812d97295001a54e2a5dd3132b80a.svg";